__turbopack_context__.v({
  "container": "IndustrySolutionsSection-module-scss-module__Zog41q__container",
  "title": "IndustrySolutionsSection-module-scss-module__Zog41q__title",
});
